<template>
    <div class="dialog-mask add-user-dialog" :class="{ open: isOpen }">    
        <div class="dialog-content">
            <div class="dialog-header">{{ 'AddRelative' | lang }}</div>   
            <div class="dialog-body">   
                <div class="form-grid-search">  
                    <div>
                        <div class="floating-label">    
                            <input v-model="fiscalCode" placeholder=" " type="text" />    
                            <label>{{ 'FiscalCode' | lang }}</label>   
                        </div>   
                        <div class="search-button"> 
                            <button @click="getUserByFiscalCode()" class="green">{{ 'Search' | lang }}</button>
                        </div>
                    </div>
                </div>
    
                <div v-if="userFound" class="form-grid-add-user">
                    <div>     
                        <div class="floating-label">  
                            <input disabled v-model="userFound.FirstName" placeholder=" " type="text" />    
                            <label>{{ 'Name' | lang }}</label>
                        </div>
                        <div class="floating-label">
                            <input disabled v-model="userFound.LastName" placeholder=" " type="text" />
                            <label>{{ 'LastName' | lang }}</label>
                        </div>
                    </div>
                    <div>
                        <div class="floating-label">
                            <input disabled v-model="userFound.BirthDate" placeholder=" " type="text" />
                            <label>{{ 'BirthDate' | lang }}</label>
                        </div>
                        <div class="floating-label">
                            <input disabled v-model="userFound.Email" placeholder=" " type="text" />   
                            <label>{{ 'Email' | lang }}</label>  
                        </div>
                    </div>
                    <div>
                        <div class="floating-label">
                            <select v-model="relativeType" placeholder=" " type="text">
                            <option v-for="(t, tidx) in relativeTypes" :value="t" :key="tidx">{{t.Label}}</option>
                           </select>
                            <label>{{ "RelativeFor" | lang }}:</label>
                        </div>
                    </div>
                </div>
                <div v-else-if="notFound" class="flexcentered bigger"> 
                    {{'NotFound' | lang}}
                    </div>

            </div>
            <div class="dialog-footer">
                <button @click="sweetClose(false)">{{ 'Close' | lang }}</button>
                <button v-if="userFound" :disabled="!relativeType" class="green" @click="addRelativeUser()">{{ 'Add' | lang }} </button>
            </div>
        </div>
    </div>
</template>

<script>
import dialogMixin from '@/mixins/dialogMixin'
import UserServices from '@/mixins/services/userServices'
export default {
    name: 'AddRelatedUser',
    mixins: [dialogMixin, UserServices],
    props: [],
    computed: {


    },
    data() {
        return {
            relativeTypes: [],
            relativeType: null,
            userFound: null,
            fiscalCode: ""
        }
    },
    mounted() {
        this.getRelativeTypes();
    },
    methods: {
        getUserByFiscalCode() {
            this._getUserByFiscalCode(this.fiscalCode).then(data => {
                if(this.userFound==null)
                {
                    this.notFound=true;
                }
                this.userFound = data;
            }).catch(err => {
                this.internalBus.$emit('notify:error', {
                    text: this.dictValue('errorOccured') + (err.status === 418 ? '[VAD]' : ''),
                    key: this.notifierKey,
                    timeout: 3000
                })
            })
        },

        getRelativeTypes() {
            this._getDataList("CustomerLink").then(data => {
                this.relativeTypes = data;
            }).catch(err => {
                console.error("failed _getDataList('CustomerLink')")
            })
        },

        addRelativeUser() {
            var request = {
                ContextWebApi: {
                    AccessType: this.isMobile ? 'mobile' : 'website',
                    CultureName: this.language,
                    SessionId: this.isLogged ? this.user.Token : null,
                    AccessMode: this.isFullLogged ? 'connectedUser' : 'anonymous',
                    SalesMode: "0",
                    EquipmentReference: this.manifest.custom_CEB
                },

                RelativeUserToLink: {
                    UserCode: this.userFound.UserCode,
                    RelativeType: this.relativeType
                },

                RelativeUserToLinkTo: {
                    UserCode: this.user.UserAccountCode,
                    RelativeType: this.relativeType
                }
            };

            this._addRelativeUser(request).then(data => {
                this.internalBus.$emit('notify:success', {
                    text: this.dictValue('Saved'),
                    key: this.notifierKey,
                    timeout: 3000
                })
                this.sweetClose(true);
            }).catch(err => {
                this.internalBus.$emit('notify:error', {
                    text: this.dictValue('errorOccured') + (err.status === 418 ? '[VAD]' : ''),
                    key: this.notifierKey,
                    timeout: 3000
                })
            })
        }

    },

    watch: {
        "fiscalCode": function() {
            this.fiscalCode = this.fiscalCode.toUpperCase();
            this.userFound = null;
            this.notFound = false;
        }
    }
}
</script>

<style lang="scss">
@import '@/assets/_vars.scss';
$dett_sto_width: 50rem;
.add-user-dialog .dialog-content {
    min-width: $dett_sto_width;
    width: $dett_sto_width;
    max-width: $dett_sto_width;
}

.search-button {
    margin-top: 25px;
    margin-left: 25px;
}

.form-grid-add-user>* {
    display: grid;
    -webkit-column-gap: 0.1rem;
    -moz-column-gap: .1rem;
    column-gap: 0.1rem;
    grid-template-columns: repeat(2, 50%);
    padding-top: 0.1rem;
}

.form-grid-search>* {
    display: grid;
    -webkit-column-gap: 0.1rem;
    -moz-column-gap: .1rem;
    column-gap: 0.1rem;
    grid-template-columns: 60% 30%;
    padding-top: 0.1rem;
}

#app.mobile .form-grid-add-user>* {
    display: grid;
    -webkit-column-gap: 0.1rem;
    -moz-column-gap: .1rem;
    column-gap: 0.1rem;
    grid-template-columns: repeat(1, 100%);
    padding-top: 0.1rem;
}

#app.mobile .add-user-dialog .dialog-content {
    min-width: calc(100vw - 2rem);
    width: calc(100vw - 2rem);
    max-width: calc(100vw - 2rem);
}

input[type=text]:disabled,
input[type=number]:disabled,
input[type=password]:disabled,
input[type=date]:disabled,
input[type=time]:disabled,
input[type=email]:disabled,
select:disabled {
    border-color: var(--white) !important;
}
</style>
